import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../../components/Dropdown";
import { FaPlus } from "react-icons/fa";
import CreateTransactionModal from "./createTransaction";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import DocumentsComponent from "./companyComponent/documents";
import RatioComponent from "./companyComponent/ratio";
import {
  clearSelectedAsset,
  fetchUserAssets,
  setSelectedAsset,
} from "../../../../../redux/slices/userAssetsSlice";
import {
  formatNumber,
  getBreadcrumbLabelsByAssetType,
  getDropdownLabelsByAssetType,
  getTabLabelsByAssetType,
  HorizontalTabButtons,
  truncateText,
  truncateToTwoDecimals,
} from "../../../../../utility/helper";
import {
  addMediaService,
  deleteMediaService,
  deleteTransaction,
  getTransaction,
} from "../../../../../services/transaction";

import ReturnComponent from "./companyComponent/returnComponent";
import {
  getGraphServices,
  getMediaService,
  getStatsService,
} from "../../../../../services/company";
import MovementComponent from "../company/companyComponent/movement";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { useLocation, useNavigate } from "react-router-dom";
import { handleErrorRedirect } from "../../../../../utility/errorRedirect";
import Breadcrumb from "../../../../../components/Breadcrumb";
import AssetGuardedActionButton from "../../../../../components/AddTransactionButton";
import CompanySkeleton from "./companyComponent/companySkeleton";

const ViewTransaction = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [graphLoading, setGraphLoading] = useState(false);
  const [companyLoading, setCompanyLoading] = useState(false);

  const dropdownOptions = getDropdownLabelsByAssetType("5");
  const [type, setType] = useState("");
  const [singleTransactionData, setSingleTransactionData] = useState({});
  const [limit, setLimit] = useState(20);
  const [error, setError] = useState(null);
  const [graphROI, setGraphROI] = useState([]);
  const [page, setPage] = useState(0);
  const [viewTransaction, setViewTransaction] = useState([]);
  const [statsData, setStatsData] = useState({});
  const [mediaData, setMediaData] = useState([]);
  const [actionTypes, setActionTypes] = useState("Create");
  const [selectedButton, setSelectedButton] = useState("Return");
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const toast = useRef(null);
  const dispatch = useDispatch();
  const userAssets = useSelector((state) => state.userAssets.data);
  const { selectedAsset, userAssetLoading } = useSelector(
    (state) => state.userAssets
  );
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const [mediaLoading, setMediaLoading] = useState(false);
  const location = useLocation();
  const id = location?.state?.id || null;
  const navigate = useNavigate();
  const tabOptions = getTabLabelsByAssetType("5");
  const breadcrumbItems = getBreadcrumbLabelsByAssetType("Company");
  const { currency } = useSelector((state) => state.user);

  const sell = viewTransaction?.transactions?.find(
    (item) => item.type === "SELL"
  );

  useEffect(() => {
    if (selectedAsset) {
      GetTransactionData();
      GetMediaData();
      GetRoiData();
      GetstatsData();
    }
  }, [selectedAsset, page, currency]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(fetchUserAssets({ assetTypeId: 5, selectedAssetId: id })).then(
      (resultAction) => {
        if (fetchUserAssets.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      }
    );
    return () => {
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, id]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  const handleOptionSelect = (option, actionTypes, data) => {
    setModalVisible(true);
    setType(option);
    setActionTypes(actionTypes);
    setSingleTransactionData(data);
  };

  const GetMediaData = async () => {
    setLoading(true);
    try {
      const response = await getMediaService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setMediaData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const GetRoiData = async () => {
    setGraphLoading(true);
    try {
      const response = await getGraphServices(selectedAsset.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setGraphROI(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setGraphLoading(false);
    }
  };

  const GetstatsData = async () => {
    setCompanyLoading(true);
    try {
      const response = await getStatsService(selectedAsset.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setStatsData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setCompanyLoading(false);
    }
  };

  const GetTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getTransaction(
        selectedAsset?.id,
        5,
        page * limit,
        limit,
        "All",
        accessToken
      );
      if (response.status === 200) {
        setViewTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleMediaDelete = async (media_id) => {
    try {
      const response = await deleteMediaService(accessToken, media_id);
      if (response) {
        GetMediaData();
        dispatch(fetchUserAssets({ assetTypeId: 5, selectedAssetId: id }));
        GetTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "File deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleCreateMedia = async (media) => {
    setMediaLoading(true);
    try {
      const response = await addMediaService(
        media,
        selectedAsset.id,
        "Company",
        accessToken
      );
      if (response) {
        GetMediaData();
        dispatch(fetchUserAssets({ assetTypeId: 5, selectedAssetId: id }));
        GetTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "File upload successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    } finally {
      setMediaLoading(false);
    }
  };

  const handleTransactionDelete = async (user) => {
    try {
      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const response = await deleteTransaction(accessToken, user?.id);
      if (response) {
        dispatch(fetchUserAssets({ assetTypeId: 5, selectedAssetId: id }));
        GetTransactionData();
        GetstatsData();
        GetRoiData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "transaction deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const confirmMediaDelete = (mediaId, fileType) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: `Are you sure you want to delete this ${
        fileType ? fileType : "Media"
      }?`,
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium border dark:border-gray-300 border-info rounded-md bg-transparent text-info dark:text-grey rounded-md focus:outline-none",
      confirmClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium dark:text-black dark:button-primary-gradient rounded-md bg-lightPrimary text-white rounded-md focus:outline-none",
      onConfirm: () => handleMediaDelete(mediaId, fileType),
    });
  };

  const confirmTransactionDelete = (transactionId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this transaction?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium border dark:border-gray-300 border-info rounded-md bg-transparent text-info dark:text-grey rounded-md focus:outline-none",
      confirmClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium dark:text-black dark:button-primary-gradient rounded-md bg-lightPrimary text-white rounded-md focus:outline-none",
      onConfirm: () => handleTransactionDelete(transactionId),
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div
        className={`relative ${
          mediaLoading ? "opacity-50 pointer-events-none" : ""
        }`}
      >
        {/* <Breadcrumb items={breadcrumbItems} className="md:ml-5 mb-2" /> */}
        <div className=" font-bold flex items-center justify-between px-4">
          <HorizontalTabButtons
            buttons={tabOptions}
            selected={selectedButton}
            onSelect={setSelectedButton}
          />
          {/* <div className="text-end">
            <CustomDropdown
              options={dropdownOptions}
              name={""}
              assetId={""}
              icon={<FaPlus />}
              direction={"right"}
              truncateText={truncateText}
              size={19}
              className={`flex items-center border border-lightPrimary dark:border-none justify-center w-10 h-9 font-bold rounded-md 
              ${
                sell
                  ? "bg-gray-400 dark:bg-gray-600 text-white cursor-not-allowed border-none"
                  : "bg-expense text-white dark:text-black dark:button-primary-gradient"
              }
            `}
              onOptionSelect={(option) =>
                !sell && handleOptionSelect(option, "Create", {})
              }
              disabled={!!sell}
            />
          </div> */}
          <AssetGuardedActionButton
            userAssets={userAssets}
            onOptionSelect={handleOptionSelect}
            dropdownOptions={dropdownOptions}
            truncateText={truncateText}
            setIsDialogOpen={setIsDialogOpen}
            openConfirmDialog={openConfirmDialog}
            navigate={navigate}
            navigatePath="/my-view"
            assetsName={"Company"}
            disabled={!!sell}
            sell={sell}
          />
        </div>
        <div className="border border-lightPrimary/40 dark:border-info/40 p-3 mx-4 my-3 dark:bg-card-custom-radials bg-[length:100%_200%] bg-white">
          <div className="text-gray-400">
            <CustomDropdown
              options={userAssets}
              name={selectedAsset?.name || "Select Asset"}
              assetId={selectedAsset?.id || null}
              onOptionSelect={(option) => dispatch(setSelectedAsset(option))}
              returnFullObject={true}
              truncateText={truncateText}
              size={19}
              disabled={!selectedAsset || !selectedAsset.name}
              className="inline-flex whitespace-nowrap disabled:cursor-not-allowed disabled:dark:opacity-75 disabled:border-none justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md text-lightPrimary dark:text-white border border-transparent hover:border-dark"
            />
          </div>
          {companyLoading || userAssetLoading ? (
            <CompanySkeleton />
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* <div className="grid grid-col-2 text-[13px] whitespace-nowrap text-info dark:text-grey">
              <div className="md:space-y-6 text-base ml-1 flex md:flex-col flex-row justify-between items-center md:items-start  text-lightPrimary dark:text-primary-gradient">
                <span className="text-2xl">{selectedAsset?.name}</span>
                <span className="">{statsData?.ownership_type ?? ""}</span>
              </div>
            </div> */}

              <div className="space-y-5 text-info dark:text-grey text-sm ml-1 w-full max-w-[18rem]">
                <div className="flex items-baseline gap-14">
                  <span className="whitespace-nowrap">Value:</span>
                  <span className="text-2xl text-lightPrimary break-anywhere dark:text-primary-gradient font-medium">
                    {formatNumber(
                      statsData?.is_sold
                        ? 0
                        : truncateToTwoDecimals(
                            Number(statsData?.valuation ?? 0) !== 0
                              ? Number(statsData.valuation)
                              : Number(statsData?.initial_balance ?? 0)
                          )
                    )}{" "}
                    {currency ? currency : ""}
                  </span>
                </div>
                <div className="flex items-baseline gap-4">
                  <span className="mr-1 whitespace-nowrap">Ownership:</span>
                  <span className="text-2xl text-lightPrimary break-all dark:text-primary-gradient font-medium">
                    {formatNumber(
                      truncateToTwoDecimals(Number(statsData?.ownership ?? 0))
                    )}{" "}
                    %
                  </span>
                </div>
                <div className="grid grid-col-2 text-[13px] text-info dark:text-grey">
                  <div className="md:space-y-6 text-base ml-1 flex md:flex-col flex-row justify-between items-center md:items-start text-lightPrimary dark:text-primary-gradient">
                    {/* <span className="text-2xl">{selectedAsset?.name}</span> */}
                    <span className="">{statsData?.ownership_type ?? ""}</span>
                  </div>
                </div>
              </div>

              <div className="space-y-5 text-sm text-info dark:text-grey w-full max-w-[25rem]">
                <div className="flex items-baseline gap-4">
                  <span className="mr-1 whitespace-nowrap">CRR:</span>
                  <span
                    className={`text-2xl break-anywhere font-medium ${
                      Number(statsData?.crr ?? 0) >= 0
                        ? "text-lightPrimary dark:text-primary-gradient"
                        : "text-expense dark:text-warning"
                    }`}
                  >
                    {formatNumber(
                      truncateToTwoDecimals(
                        Math.abs(Number(statsData?.crr ?? 0))
                      )
                    )}{" "}
                    {currency ? currency : ""}
                  </span>
                </div>
                <div className="flex items-baseline gap-4">
                  <span className="mr-1 whitespace-nowrap">ROI:</span>
                  <span
                    className={`text-2xl break-anywhere font-medium ${
                      Number(statsData?.roi ?? 0) >= 0
                        ? "text-lightPrimary dark:text-primary-gradient"
                        : "text-expense dark:text-warning"
                    }`}
                  >
                    {formatNumber(
                      truncateToTwoDecimals(
                        Math.abs(Number(statsData?.roi ?? 0))
                      )
                    )}
                    %
                  </span>
                </div>
              </div>

              <div className="grid grid-col-2 text-sm text-info dark:text-grey w-full max-w-[25rem]">
                <div className="space-y-3">
                  <div className="flex items-baseline gap-10">
                    <span>
                      {Number(statsData?.realized ?? 0) >= 0
                        ? "Realised Profit:"
                        : "Realised Loss:"}
                    </span>

                    <span
                      className={`text-2xl break-anywhere font-medium ${
                        Number(statsData?.realized ?? 0) >= 0
                          ? "text-lightPrimary dark:text-primary-gradient"
                          : "text-expense dark:text-warning"
                      }`}
                    >
                      {formatNumber(
                        truncateToTwoDecimals(
                          Math.abs(Number(statsData?.realized ?? 0))
                        )
                      )}{" "}
                      {currency || ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-6">
                    <span className="whitespace-nowrap">
                      {Number(statsData?.unrealized ?? 0) >= 0
                        ? "Unrealised Profit:"
                        : "Unrealised Loss:"}
                    </span>

                    <span
                      className={`text-2xl break-anywhere font-medium ${
                        Number(statsData?.unrealized ?? 0) >= 0
                          ? "text-lightPrimary dark:text-primary-gradient"
                          : "text-expense dark:text-warning"
                      }`}
                    >
                      {formatNumber(
                        truncateToTwoDecimals(
                          Math.abs(Number(statsData?.unrealized ?? 0))
                        )
                      )}{" "}
                      {currency || ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-12">
                    <span className="whitespace-nowrap">Market Value:</span>
                    <span className="text-lightPrimary break-anywhere text-2xl dark:text-primary-gradient font-medium">
                      {formatNumber(
                        truncateToTwoDecimals(
                          Number(statsData?.market_value ?? 0)
                        )
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid  grid-col-2 text-sm text-info dark:text-grey">
                <div className="space-y-3 w-full max-w-[25rem]">
                  <div className="flex items-baseline gap-[5.3rem]">
                    <span className="whitespace-nowrap">Income:</span>
                    <span className="text-lightPrimary text-2xl break-anywhere dark:text-primary-gradient font-medium">
                      {formatNumber(
                        truncateToTwoDecimals(Number(statsData?.income ?? 0))
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-20">
                    <span className="whitespace-nowrap">Expense:</span>
                    <span className="text-expense break-anywhere text-2xl dark:text-warning font-medium">
                      {formatNumber(
                        truncateToTwoDecimals(Number(statsData?.expense ?? 0))
                      )}{" "}
                      {currency ? currency : ""}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-[1.2rem]">
                    <span className="">EBITDA Multiples:</span>
                    <span className="text-lightPrimary text-2xl break-all dark:text-primary-gradient font-medium">
                     0
                      x
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-5 mx-4 dark:bg-card-custom-radials bg-white">
          {selectedButton === "Return" && (
            <ReturnComponent
              graphROI={graphROI}
              selectedAsset={selectedAsset}
              graphLoading={graphLoading}
              companyLoading={companyLoading}
            />
          )}
          {selectedButton === "Documents" && (
            <DocumentsComponent
              handleMediaDelete={confirmMediaDelete}
              mediaData={mediaData}
              handleCreateMedia={handleCreateMedia}
            />
          )}
          {selectedButton === "Ratio" && <RatioComponent />}
          {selectedButton === "Movements" && (
            <MovementComponent
              confirmDelete={confirmTransactionDelete}
              handleOptionSelect={handleOptionSelect}
              viewTransaction={viewTransaction}
              setLimit={setLimit}
              limit={limit}
              setPage={setPage}
              page={page}
              selectedAsset={selectedAsset}
              currency={currency}
            />
          )}
        </div>

        <CreateTransactionModal
          visible={modalVisible}
          singleTransactionData={singleTransactionData}
          actionTypes={actionTypes}
          fetchTransactionData={GetTransactionData}
          GetstatsData={GetstatsData}
          GetRoiData={GetRoiData}
          viewTransaction={viewTransaction}
          onHide={() => {
            setModalVisible(false);
          }}
          SelectType={type}
          toast={toast}
          loading={loading}
          setLoading={setLoading}
          assetName={selectedAsset}
        />
      </div>
      {mediaLoading && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50">
          <ProgressSpinner style={{ width: "60px", height: "60px" }} />
        </div>
      )}
    </>
  );
};

export default ViewTransaction;
